<div
	fxLayout="row"
	fxLayoutAlign="center"
	ngClass="p-b-xxl m-b-xl p-t-xxl m-t-l"
>
	<div
		fxLayout="column"
		class="dark-grey-texts"
		fxFlex.gt-xs="100%"
		fxFlex.xs="90%"
	>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column-reverse"
			fxFlex="100%"
			fxLayoutAlign="center"
			fxLayoutGap="3%"
		>
			<div
				fxLayout="column"
				fxFlex.sm="45%"
				fxFlex.md="40%"
				fxFlex.lg="28%"
				fxFlex.gt-lg="38%"
				fxLayoutAlign="center"
			>
				<div fxLayout="row" ngClass.xs="p-t-xl">
					<mat-card-title
						class="inc-largetext-height"
						i18n="@@donation_plugin_donationBtnPluginHomeOrganization"
						>Donation button plugin</mat-card-title>
				</div>
				<div fxLayout="row">
					<p
						class="inc-span-height"
						i18n="@@homepage_organisation_donationPlugin_content"
					>
						Raise money for charities by adding the donation plugin to your
						website. Create the best crowdfunding site for charity. Free
						installation within a couple of minutes.
					</p>
				</div>
				<div fxLayout="row" fxLayoutAlign="flex-start center" ngClass="p-t-m">
					<a mat-button color="accent" (click)="routeToLearnMore()">
						<span class="mat-headline-6" i18n="@@button_learnMore"
							>Learn More</span
						></a
					>
				</div>
			</div>
			<div
				fxLayout="column"
				fxFlex.gt-sm="35%"
				fxFlex.sm="40%"
				ngClass.xs="p-t-xl m-t-m"
			>
				<img
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/homeOrganisationPlugin/public"
				/>
			</div>
		</div>
	</div>
</div>
